/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ObjectResult } from '../../models/object-result';

export interface ApiPlayerNotesIdDelete$JsonOdataMetadataMinimalOdataStreamingFalse$Params {
  id: number;
}

export function apiPlayerNotesIdDelete$JsonOdataMetadataMinimalOdataStreamingFalse(http: HttpClient, rootUrl: string, params: ApiPlayerNotesIdDelete$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
  const rb = new RequestBuilder(rootUrl, apiPlayerNotesIdDelete$JsonOdataMetadataMinimalOdataStreamingFalse.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json;odata.metadata=minimal;odata.streaming=false', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ObjectResult>;
    })
  );
}

apiPlayerNotesIdDelete$JsonOdataMetadataMinimalOdataStreamingFalse.PATH = '/api/player-notes/{id}';
